<template>
  <CommonModal>
    <template slot="header">
      <h3>Add Document Type</h3>
    </template>
    <template slot="body">
      <div style="overflow: auto; height: 450px">
        <table class="write_tbl">
          <tbody>
            <tr>
              <th>ID</th>
              <td>{{form.doctypeVO.doctypeId}}</td>
            </tr>          
            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="form.doctypeVO.doctypeName"
                  v-validate="'required'"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="form.doctypeVO.doctypeDesc"
                ></textarea>
              </td>
            </tr>
            <tr>
              <th>사용여부</th>
              <td>
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="form.doctypeVO.useYn"
                    value="Y"
                  />
                  Use</label
                >
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="form.doctypeVO.useYn"
                    value="N"
                  />
                  Unused</label
                >
              </td>
            </tr>
          </tbody>
        </table>

        <!-- <table class="write_tbl" v-for="(item, index) in form.languages" :key="index">
          <tbody>
            <tr>
              <th>언어</th>
              <td>
                {{ item.language.codeName }}
              </td>
            </tr>

            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="item.doctypeName"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="item.doctypeDesc"
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table> -->
      </div>
    </template>
    <template slot="footer">
      <slot name="footer"> </slot>
    </template>
  </CommonModal>
</template>

<script>
import CommonModal from "@/components/modal/CommonModal";
import {
  updateDocType,
  fetchDoctypeForm,
  addDocType,
  getDocTypeAndLabel,
  checkDocTypeNameDuplication,
} from "@/api/doctype";

export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      form: {
        doctypeVO: {
          doctypeId: "",
          doctypeName: "",
          doctypeDesc: "",
          useYn: "Y",
        },

        languages: [],
      },
      doctype: "",
    };
  },
  methods: {
    async save() {
      try {
        const response = await addDocType(this.form);
        console.log(response);
        if (response.data.status) {
          this.reset();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchData(doctypeId) {
      this.form.doctypeId = doctypeId;
      try {
        const response = await getDocTypeAndLabel(doctypeId);
        console.log(response);
        this.form = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async update() {
      const validForm = await this.$validator.validateAll();
      if (validForm) {
        //docTypeName 중복확인
        const { data } = await checkDocTypeNameDuplication(this.form);
        this.doctype = data.doctype;
        if (this.doctype == null || this.doctype == "") {
          try {
            const response = await updateDocType(this.form);
            return response.data.status;
          } catch (error) {
            console.log(error);
          }
        } else {
          return "alert.alreadyExist";
        }
      } else {
        return "alert.plzCheckAllValues";
      }
    },
    reset() {
      this.form.doctypeId = "";
      this.form.doctypeName = "";
      this.form.doctypeDesc = "";
      this.form.useYn = "Y";
    },
    async fetchDoctypeForm() {
      const response = await fetchDoctypeForm();
      console.log(response);
      this.form.languages = response.data.forms;
    },
  },
};
</script>

<style></style>
